import React from 'react';
import CompleteForm from '../CompleteForm';

/**
 * Export a component that render confirm-email page.
 */

const ConfirmEmailPage = ({ match: { params } }) => (
	<CompleteForm
		name='Passwort ändern'
		requestPath={`/reset/confirm-email/${params.uniqueId}/${params.mail}`}
		showEmailField={true}
		showPasswordField={true}
		showCopiedPasswordField={true}
		showSubmitButton={true}
		submitButton='Bestätigen'
	/>
);
export default ConfirmEmailPage;
